import { TimeLine } from '../../../types/state';
import { sportingAPI } from '../api';
import { normalizeSportingTimeLine } from '../utils/normalizeSportingTimeLine';

export const getTimeLines = async (): Promise<TimeLine[]> => {
  const timeLines = await sportingAPI.booking.getTimeLines();

  return timeLines.map(normalizeSportingTimeLine.toTimeLine);
};
